export async function ajax(url, { method = 'GET', body = null, expectHtml = false } = {}) {
    return new Promise((resolve, reject) => {
        const opts = {
            url,
            method: method.toUpperCase(),
            dataType: expectHtml ? 'html' : 'json',
            success: (resp) => {
                // если ожидаем JSON и есть поле status: 'success' — принять
                if (!expectHtml && resp && (resp.status === 'success' || resp.success === true)) {
                    resolve(resp);
                } else if (!expectHtml && resp && (resp.status === 'error' || resp.success === false)) {
                    reject(resp);
                } else {
                    // либо html либо произвольный объект
                    resolve(resp);
                }
            },
            error: (xhr, textStatus, errorThrown) => {
                let message = 'Ошибка при выполнении запроса';
                try {
                    const json = xhr.responseJSON;
                    if (json && (json.message || json.error)) message = json.message || json.error;
                } catch (e) {}
                reject({ status: 'error', message, xhr, textStatus, errorThrown });
            }
        };

        // если есть тело — отправляем как JSON (можно изменить при надобности)
        if (body !== null) {
            // если это FormData — передать как есть
            if (body instanceof FormData) {
                opts.data = body;
                opts.processData = false;
                opts.contentType = false;
            } else {
                // отправляем JSON
                opts.contentType = 'application/json; charset=utf-8';
                opts.data = JSON.stringify(body);
            }
        }

        $.ajax(opts);
    });
}
